import maisonMercy from '../assets/maison_mercy_le_bas_1.png';
import appartHayange from '../assets/appartement_hayange_renove.png';
import pavillonMercy from '../assets/pavillon_moderne_mercy.png';
import terrainSpincourt from '../assets/terrain_spincourt.png';

export const MOCK_PROPERTIES = [
    {
        id: '1',
        title: "Maison individuelle à Ottange",
        catch_phrase: "Secteur calme, proche frontière Luxembourg",
        price: 450000,
        type: "Maison",
        status: "Vente",
        surface: 145,
        city: "Ottange",
        description: "Superbe maison individuelle située sur les hauteurs d'Ottange. Grand salon lumineux, jardin entretenu et garage motorisé.",
        image: maisonMercy,
        features: ["4 Chambres", "Terrasse", "Proche BUS LUX"],
        is_favorite: true,
        marketing_status: "Exclusivité",
    },
    {
        id: '2',
        title: "Appartement de standing à Dudelange",
        catch_phrase: "Prestations haut de gamme",
        price: 620000,
        type: "Appartement",
        status: "Vente",
        surface: 95,
        city: "Dudelange",
        description: "Appartement moderne dans une résidence calme. Finitions soignées, balcon avec vue dégagée et parking inclus.",
        image: appartHayange,
        features: ["2 Chambres", "Parking", "Cuisine Équipée"],
        marketing_status: "Sous Compromis",
    },
    {
        id: '3',
        title: "Maison de village à Fontoy",
        catch_phrase: "Charme et authenticité",
        price: 315000,
        type: "Maison",
        status: "Vente",
        surface: 120,
        city: "Fontoy",
        description: "Belle maison de village rénovée offrant de beaux volumes. Idéal premier achat à quelques minutes de l'Aumetz.",
        image: pavillonMercy,
        features: ["3 Chambres", "Cheminée", "Pas de travaux"],
        marketing_status: "Nouveauté",
    },
    {
        id: '4',
        title: "Terrain constructible Volmerange",
        catch_phrase: "Libre de constructeur",
        price: 185000,
        type: "Terrain",
        status: "Vente",
        surface: 600,
        city: "Volmerange-les-Mines",
        description: "Rare opportunité à Volmerange-les-Mines. Terrain plat, viabilisé, idéalement situé pour votre futur projet.",
        image: terrainSpincourt,
        features: ["Viabilisé", "Secteur Prisé", "Proche Frontière"],
        marketing_status: "Vendu",
    }
];
